import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'wouter';
import gsap from 'gsap';
import '../styles/cinematic.css';
import './Navbar.css';
import useStore from '../store';

const Navbar = () => {
    const links = ["Home", "Events", "Sponsors", "Memories", "Performers", "Team", "Contact Us"];
    const [location, setLocation] = useLocation();
    const setTargetSection = useStore((state) => state.setTargetSection);
    const [isOpen, setIsOpen] = useState(false);

    const handleNavClick = (e, link) => {
        e.preventDefault();
        setIsOpen(false);

        if (link === 'Home') {
            if (location !== '/') setLocation('/');
            useStore.setState({ activeCategory: null, zoomedCategoryId: null, isWheelLocked: false });
            setTargetSection('hero');
            window.scrollTo(0, 0);
            return;
        }

        if (link === 'Team') {
            setLocation('/team');
            return;
        }

        if (link === 'Memories') {
            setLocation('/memories');
            return;
        }

        if (link === 'Performers') {
            setLocation('/performers');
            return;
        }

        if (link === 'Contact Us') {
            setLocation('/contact');
            return;
        }

        // For Events and Sponsors, set target section and navigate to home if needed
        const section = link.toLowerCase();
        if (section === 'events' || section === 'sponsors') {
            useStore.setState({ activeCategory: null, zoomedCategoryId: null, isWheelLocked: false });
            setTargetSection(section);
        }

        if (location !== '/') {
            setLocation('/');
        }
    };

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    return (
        <nav className="navbar">
            <div className={`hamburger ${isOpen ? 'open' : ''}`} onClick={toggleMenu}>
                <div className="bar"></div>
                <div className="bar"></div>
                <div className="bar"></div>
            </div>

            <ul className={`nav-links ${isOpen ? 'open' : ''}`}>
                {links.map((link, index) => (
                    <li key={index} style={{ position: 'relative' }}>
                        <a
                            href={`#${link.replace(' ', '-').toLowerCase()}`}
                            onClick={(e) => handleNavClick(e, link)}
                            className="nav-link"
                        >
                            {link}
                        </a>
                    </li>
                ))}
            </ul>
        </nav>
    );
};

export default Navbar;
